import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import '../styles/pages/NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>Página Não Encontrada - App</title>
        <meta name="description" content="A página que você está procurando não foi encontrada." />
      </Helmet>

      <div className="notfound-page">
        <Header />
        
        <main className="notfound-content">
          <div className="container">
            <div className="notfound-card">
              <div className="notfound-icon">404</div>
              <h1 className="notfound-title">Página Não Encontrada</h1>
              <p className="notfound-text">
                Ops! A página que você está procurando não existe ou foi movida.
              </p>
              
              <div className="notfound-actions">
                <Link to="/" className="btn btn-primary">
                  Voltar para Home
                </Link>
                <Link to="/contato" className="btn btn-outline">
                  Reportar Problema
                </Link>
              </div>

              <div className="notfound-suggestions">
                <p>Páginas úteis:</p>
                <ul>
                  <li><Link to="/">Página Inicial</Link></li>
                  <li><Link to="/sobre">Sobre Nós</Link></li>
                  <li><Link to="/#download">Baixar o App</Link></li>
                  <li><Link to="/contato">Contato</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default NotFoundPage;
